import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class LayoutState {

    private loaderSource = new BehaviorSubject<boolean>(false);
    isLoading$ = this.loaderSource.asObservable();

    setLoadingStatus(isLoading: boolean): void {
        if (this.loaderSource.value === isLoading) {
          return;
        }
        requestAnimationFrame(() => {
          this.loaderSource.next(isLoading);
        });
      }
}